import {
  desaturate as _desaturate,
  saturate as _saturate,
  transparentize as _transparentize,
  toRgba,
} from "color2k";

// Include any functions we wish to expose from color2k
export { darken, lighten, toHex, toRgba } from "color2k";

export type RGBArray = [number, number, number];

/**
 * Converts an RGB array to a CSS string representation.
 * @param rgb - The RGB array to convert.
 * @param opacity - Optional opacity value.
 * @returns A CSS string representation of the RGB array, using `rgb()`, or `rgba()` if an opacity value is provided.
 */
export const arrayToRgbString = (rgb: RGBArray, opacity?: number): string => {
  return opacity === undefined
    ? `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`
    : `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${opacity})`;
};

/**
 * Transparentizes an input color.
 *
 * @param color - The color string to transparentize.
 * @param amount - The amount to increase the opacity of the color by, given as a decimal between 0 and 1.
 * @returns An RGBA color string.
 */
export const transparentize = (color: string, amount: number): string => {
  return toRgba(_transparentize(color, amount));
};

/**
 * Saturates a color.
 *
 * @param color - Input color
 * @param amount - The amount to saturate, given as a decimal between 0 and 1
 * @returns An RGBA color string.
 */
export const saturate = (color: string, amount: number): string => {
  return toRgba(_saturate(color, amount));
};

/**
 * Desaturates a color.
 *
 * @param color - Input color
 * @param amount - The amount to desaturate, given as a decimal between 0 and 1
 * @returns An RGBA color string.
 */
export const desaturate = (color: string, amount: number): string => {
  return toRgba(_desaturate(color, amount));
};
